import { Reducer } from 'redux'
import { Action, ActionTypes } from 'mobile/Actions/actionConstants'
import {IOrder} from "shared/Types/appTypes";

export interface IExtendMeetingModal {
    open: boolean
    order: IOrder | null
}


const initialState: IExtendMeetingModal = {
    open: false,
    order: null,
};

const multiSelectModalReducer: Reducer<IExtendMeetingModal, Action> = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.OPEN_EXTEND_MEETING_MODAL:
            return {
                ...state,
                open: true,
                order: action.order,
            };
        case ActionTypes.CLOSE_EXTEND_MEETING_MODAL:
            return {
                ...state,
                open: false,
            };
        default:
            return state
    }
};

export default multiSelectModalReducer
